export default __webpack_public_path__ + "static/4_18-e2c83b6e372862a094842a6a3c14dbeb.png";